<template>
  <v-card
    v-if="childSchema"
    class="mb-4"
    flat
    tile
  >
    <v-card-text class="px-0">
      <v-row class="d-flex align-center">
        <v-col>
          <h2
            class="fs-22 fw-600"
            tabindex="0"
          >
            {{ subsidyProgram.name }}
          </h2>
        </v-col>
      </v-row>

      <v-row>
        <v-col>
          <p class="c-light-black fs-16 fw-500 mb-0">
            {{ $bct(subsidyProgram.description) }}
          </p>
        </v-col>
      </v-row>

      <template v-if="subsidies.length > 0">
        <v-row
          v-for="subsidy in subsidies"
          :key="subsidy.id"
        >
          <v-col>
            <template v-if="subsidy.submitted_at">
              <v-divider class="my-4" />

              <v-row
                class="mb-2"
                dense
              >
                <v-col class="d-flex align-center">
                  <router-link
                    :to="{ name: 'SubsidyReview', params: { subsidyId: subsidy.id } }"
                    class="td-none"
                  >
                    <v-icon
                      class="material-icons-outlined td-none"
                      color="primary"
                      icon="check_circle"
                      size="24"
                      start
                    />

                    <LongDateTime
                      :date="subsidy.submitted_at"
                      class="underlined"
                      data-cy="app_submitted"
                      prefix="Application submitted at"
                    />
                  </router-link>
                </v-col>
              </v-row>
            </template>
            <template v-else>
              <v-btn
                :block="$vuetify.display.smAndDown"
                :to="{ name: 'SubsidyContinue', params: { subsidyId: subsidy.id } }"
                class="focus-very-visible"
                color="primary"
                data-cy="continue-button"
                variant="outlined"
                tile
              >
                <span>{{ $bct('Continue') }} {{ subsidyProgram.name }}</span>
              </v-btn>
            </template>
          </v-col>
        </v-row>

        <v-row v-if="subsidies.filter((subsidy) => !subsidy.submitted_at)">
          <v-col>
            <v-btn
              @click="create"
              :block="$vuetify.display.smAndDown"
              class="focus-very-visible"
              color="primary"
              data-cy="re-apply-button"
              variant="outlined"
              tile
            >
              {{ $bct('Re-apply') }}
            </v-btn>
          </v-col>
        </v-row>
      </template>

      <template v-else>
        <v-row>
          <v-col>
            <v-btn
              @click="create"
              :block="$vuetify.display.smAndDown"
              :loading="processing"
              class="focus-very-visible"
              color="primary"
              data-cy="start-button"
              variant="outlined"
              tile
            >
              <span>{{ $bct('Start') }} {{ subsidyProgram.name }}</span>
            </v-btn>
          </v-col>
        </v-row>
      </template>
    </v-card-text>
  </v-card>
</template>

<script setup>
import { useRouter } from 'vue-router';
import LongDateTime from '@/shared/components/LongDateTime.vue';
import useApi from '@/shared/composables/useApi';
import useEventBus from '@/shared/composables/useEventBus';

const { api } = useApi();
const eventBus = useEventBus();
const router = useRouter();
const $bct = inject('translator');

const props = defineProps({
  childData: {
    type: Object,
    default: null,
  },
  childSchema: {
    type: Object,
    default: null,
  },
  subsidies: {
    type: Array,
    default: () => [],
  },
  subsidyProgram: {
    type: Object,
    default: null,
  },
});

const processing = ref(false);

const create = () => {
  processing.value = true;
  api.subsidy.create(
    { child_id: props.childData.id, subsidy_program_id: props.subsidyProgram.id },
    (resp) => {
      router.push({ name: 'SubsidyContinue', params: { subsidyId: resp.data.id } });
    },
    (err) => {
      eventBus.chime(err.response.data.errors[0]);
    },
  );
};
</script>
